"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Griddable = Griddable;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function Griddable(props) {
  var clickable = props.clickable,
    expandable = props.expandable,
    selectable = props.selectable,
    _props$hoverable = props.hoverable,
    hoverable = _props$hoverable === void 0 ? true : _props$hoverable,
    _props$noBorderLastRo = props.noBorderLastRow,
    noBorderLastRow = _props$noBorderLastRo === void 0 ? false : _props$noBorderLastRo,
    items = props.items,
    getId = props.getId;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    disableAll = _useState2[0],
    setDisableAll = _useState2[1];
  var onLocalChange = function onLocalChange(item) {
    var id = getId(item);
    var index = selectable.selected.indexOf(id);
    var ids;
    if (index < 0) {
      ids = [].concat(_toConsumableArray(selectable.selected), [id]);
    } else {
      ids = selectable.selected.filter(function (el, i) {
        return i !== index;
      });
    }
    inform(ids);
  };
  var onLocalChangeAll = function onLocalChangeAll(checked) {
    var ids;
    if (checked) {
      ids = items.map(function (item) {
        return getId(item);
      });
    } else {
      ids = selectable.fixed || [];
    }
    inform(ids);
  };
  var inform = function inform(ids) {
    if (!selectable) return;
    var selectedItems = items.filter(function (el) {
      return ids.indexOf(getId(el)) >= 0;
    });
    selectable.onChange(ids, selectedItems);
  };
  (0, _react.useEffect)(function () {
    var _a;
    if (selectable) {
      var ids = items.map(getId);
      if ((_a = selectable.fixed) === null || _a === void 0 ? void 0 : _a.length) {
        var notFixed = ids.filter(function (el) {
          return selectable.fixed.indexOf(el) < 0;
        });
        setDisableAll(notFixed.length === 0);
      } else {
        setDisableAll(ids.length === 0);
      }
    } else {
      setDisableAll(false);
    }
  }, [selectable, items, getId]);
  var gridableBody = function gridableBody() {
    if (props.loading) {
      return /*#__PURE__*/_react["default"].createElement(GriddableRowGeneric, null, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "center",
        justifyItems: "center",
        alignContent: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: "auto"
      }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
        size: "1rem",
        color: "secondary"
      }))));
    }
    if (props.error) {
      return /*#__PURE__*/_react["default"].createElement(GriddableRowGeneric, {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "caption",
        color: "error",
        component: "h6",
        textAlign: "center"
      }, props.error));
    }
    if (items.length === 0 && props.empty) {
      return /*#__PURE__*/_react["default"].createElement(GriddableRowGeneric, {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "caption",
        component: "h6",
        textAlign: "center"
      }, props.empty));
    }
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, items.map(function (item, indexRow) {
      return /*#__PURE__*/_react["default"].createElement(GriddableRowBody, {
        key: props.getId(item),
        index: indexRow,
        item: item,
        total: items.length,
        columns: props.columns,
        getId: props.getId,
        onLocalChange: onLocalChange,
        onLocalChangeAll: onLocalChangeAll,
        selectable: !!selectable,
        selectedIds: (selectable === null || selectable === void 0 ? void 0 : selectable.selected) || [],
        fixedIds: (selectable === null || selectable === void 0 ? void 0 : selectable.fixed) || [],
        clickable: clickable,
        expandable: expandable,
        hoverable: hoverable,
        noBorderLastRow: noBorderLastRow
      });
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(GriddableRowHeader, {
    className: "GridableHeader",
    container: true,
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center"
  }, props.columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement(GriddableCellTitle, {
      key: index,
      column: column,
      selectable: selectable && index === 0,
      disabled: disableAll,
      total: items.length,
      selected: (selectable === null || selectable === void 0 ? void 0 : selectable.selected) || [],
      onChangeAll: onLocalChangeAll
    });
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, gridableBody()));
}
var GriddableRow = (0, _styles.styled)(_material.Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.divider,
    minHeight: theme.spacing(6),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    '&:is(.GriddableRowHoverable):not(.GridableHeader):hover': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[50]
    },
    '&:is(.GriddableRowClickable):not(.GridableHeader)': {
      cursor: 'pointer'
    },
    '&:is(.GriddableRowSelected):not(.GridableHeader)': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[200]
    },
    '&:is(.GriddableRowNoBorderLast):not(.GridableHeader)': {
      borderBottomWidth: 0
    }
  };
});
var GriddableRowHeader = (0, _styles.styled)(GriddableRow)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.grey[100]
  };
});
var GriddableDetailContainer = (0, _styles.styled)(_material.Grid)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    borderTop: '1px dashed',
    borderTopColor: theme.palette.divider,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(0.5)
  };
});
var GriddableCheckbox = (0, _styles.styled)(_material.Checkbox)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    zIndex: 1
  };
});
function GriddableRowDetail(props) {
  var item = props.item,
    expanded = props.expanded,
    mapper = props.mapper;
  return /*#__PURE__*/_react["default"].createElement(_material.Hidden, {
    xsUp: !expanded,
    implementation: "js"
  }, /*#__PURE__*/_react["default"].createElement(GriddableDetailContainer, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": expanded
  }, mapper(item))));
}
var GriddableCellBox = (0, _styles.styled)(_material.Box)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    width: '100%',
    minWidth: '100%',
    minHeight: theme.spacing(5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    justifyContent: 'flex-start'
  };
});
function GriddableCell(props) {
  var column = props.column,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_material.Hidden, {
    xsDown: column.xs === false,
    smDown: column.sm === false,
    mdDown: column.md === false,
    lgDown: column.lg === false,
    xlDown: column.xl === false
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: column.xs,
    sm: column.sm,
    md: column.md,
    lg: column.lg,
    xl: column.xl
  }, /*#__PURE__*/_react["default"].createElement(GriddableCellBox, null, children)));
}
function GriddableCellValue(props) {
  var column = props.column,
    item = props.item,
    id = props.id,
    selected = props.selected,
    disabled = props.disabled,
    indexColumn = props.indexColumn,
    indexRow = props.indexRow,
    onChange = props.onChange;
  var title = column.title,
    textAlign = column.textAlign,
    converter = column.converter;
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    valueNode = _useState4[0],
    setValueNode = _useState4[1];
  (0, _react.useEffect)(function () {
    var value = converter(item, indexColumn, indexRow);
    var type = _typeof(value);
    if (type === 'string' || type === 'number') {
      setValueNode(/*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "body2",
        component: "h6",
        align: textAlign
      }, value));
    } else {
      setValueNode(value);
    }
  }, [item, indexColumn, indexRow, title, textAlign, converter]);
  var handleSelection = function handleSelection(event, checked) {
    onChange(item);
  };
  return /*#__PURE__*/_react["default"].createElement(GriddableCell, {
    column: column
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center",
    spacing: 1
  }, props.selectable && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(GriddableCheckbox, {
    size: "small",
    id: id,
    name: id,
    value: id,
    checked: selected,
    disabled: disabled,
    onChange: handleSelection
  }))), props.expandable && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    size: "small",
    onClick: props.onExpand
  }, props.expanded ? (/*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], {
    fontSize: "small"
  })) : (/*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
    fontSize: "small"
  }))))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, valueNode)));
}
function GriddableRowBody(_ref6) {
  var index = _ref6.index,
    item = _ref6.item,
    total = _ref6.total,
    selectable = _ref6.selectable,
    columns = _ref6.columns,
    clickable = _ref6.clickable,
    expandable = _ref6.expandable,
    selectedIds = _ref6.selectedIds,
    fixedIds = _ref6.fixedIds,
    getId = _ref6.getId,
    onLocalChange = _ref6.onLocalChange,
    hoverable = _ref6.hoverable,
    noBorderLastRow = _ref6.noBorderLastRow;
  var _a;
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    id = _useState6[0],
    setId = _useState6[1];
  var _useState7 = (0, _react.useState)((_a = expandable === null || expandable === void 0 ? void 0 : expandable.expanded) !== null && _a !== void 0 ? _a : false),
    _useState8 = _slicedToArray(_useState7, 2),
    expanded = _useState8[0],
    setExpanded = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    selected = _useState10[0],
    setSelected = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    disabled = _useState12[0],
    setDisabled = _useState12[1];
  (0, _react.useEffect)(function () {
    if (selectable && getId) {
      var _id = getId(item);
      setId(_id);
      setSelected(selectedIds.indexOf(_id) >= 0);
      setDisabled(fixedIds ? fixedIds.indexOf(_id) >= 0 : false);
    } else {
      setId('');
      setSelected(false);
      setDisabled(false);
    }
  }, [item, selectable, selectedIds, fixedIds, getId]);
  var onExpand = function onExpand(event) {
    event.stopPropagation();
    setExpanded(!expanded);
  };
  return /*#__PURE__*/_react["default"].createElement(GriddableRow, {
    container: true,
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center",
    onClick: clickable ? function () {
      return clickable.onClick(item, index);
    } : undefined,
    className: (0, _clsx["default"])({
      GriddableRowHoverable: !!hoverable,
      GriddableRowNoBorderLast: !!noBorderLastRow && total === index + 1,
      GriddableRowClickable: !!clickable,
      GriddableRowSelected: selected
    })
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, columns.map(function (column, indexColumn) {
    return /*#__PURE__*/_react["default"].createElement(GriddableCellValue, {
      key: indexColumn,
      id: id,
      column: column,
      item: item,
      indexRow: index,
      indexColumn: indexColumn,
      selected: selected,
      selectable: selectable && indexColumn === 0,
      disabled: disabled,
      onChange: onLocalChange,
      expandable: !!expandable && indexColumn === 0,
      expanded: expanded,
      onExpand: onExpand
    });
  }), (expandable === null || expandable === void 0 ? void 0 : expandable.mapper) && (/*#__PURE__*/_react["default"].createElement(GriddableRowDetail, {
    item: item,
    expanded: expanded,
    mapper: expandable.mapper
  }))));
}
var GriddableRowGeneric = function GriddableRowGeneric(_ref7) {
  var children = _ref7.children,
    _ref7$fullWidth = _ref7.fullWidth,
    fullWidth = _ref7$fullWidth === void 0 ? true : _ref7$fullWidth;
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(GriddableRow, {
    container: true,
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center",
    className: "GriddableRowNoBorderLast"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: fullWidth ? 12 : 'auto'
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    py: 1
  }, children))));
};
function GriddableCellTitle(props) {
  var column = props.column,
    total = props.total,
    selected = props.selected,
    selectable = props.selectable;
  var title = column.title,
    textAlign = column.textAlign;
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    titleNode = _useState14[0],
    setTitleNode = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    checked = _useState16[0],
    setChecked = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    indeterminate = _useState18[0],
    setIndeterminate = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    disabled = _useState20[0],
    setDisabled = _useState20[1];
  (0, _react.useEffect)(function () {
    setChecked(selected.length > 0 && selected.length === total);
    setIndeterminate(selected.length > 0 && selected.length < total);
    setDisabled(props.disabled || total === 0);
  }, [total, selected, props.disabled]);
  (0, _react.useEffect)(function () {
    if (typeof title !== 'string') {
      setTitleNode(title);
    } else {
      setTitleNode(/*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "body2",
        component: "h6",
        align: textAlign
      }, /*#__PURE__*/_react["default"].createElement("strong", null, title)));
    }
  }, [title, textAlign]);
  var handleAllCheckboxs = function handleAllCheckboxs(event, checked) {
    props.onChangeAll(checked);
  };
  return /*#__PURE__*/_react["default"].createElement(GriddableCell, {
    column: column
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    alignItems: "center",
    alignContent: "center",
    spacing: 1
  }, selectable && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(GriddableCheckbox, {
    size: "small",
    id: "gridable-all",
    name: "gridable-all",
    checked: checked,
    indeterminate: indeterminate,
    onChange: handleAllCheckboxs,
    disabled: disabled
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, titleNode)));
}